
import { Map, Marker, NavigationControl, Popup } from 'maplibre-gl';

//Maplist
const maplistentries = document.querySelectorAll('[data-behaviour="maplist-entry"]');

// ## Maps ##
const maps = document.querySelectorAll('[data-behaviour="map"]');
if (maps) {
    const api_key = '8d8bf301d9d530613f96f2c42b47551a';
    maps.forEach(function (mapElement) {
        const center = mapElement.getAttribute('data-center');
        const map = new Map({
            container: mapElement,
            style: `https://www.goodmaps.de/map-styles/${api_key}`, // style URL
            center: center ? center.split(',') : [9.631947, 54.251622], // starting position [lng, lat]
            zoom: 7, // starting zoom
            cooperativeGestures: true,
        });
        map.addControl(new NavigationControl());

        const dataElement = mapElement.querySelector('[data-behaviour="map-locations"]');
        const locations = JSON.parse(dataElement.textContent);
        //console.log(dataElement.textContent);

        var markers = [];

        const mapfilters = document.querySelectorAll('[data-behaviour="map-filter"]');

        // Popup size is shared by all popups of this map, so the choice persists between markers
        let popupWide = false;
        const labelWiden = mapElement.getAttribute('data-label-widen') || 'Breiter anzeigen';
        const labelNarrow = mapElement.getAttribute('data-label-narrow') || 'Schmaler anzeigen';
        const labelClose = mapElement.getAttribute('data-label-close') || 'Schließen';

        locations.forEach(function (location) {
            // Opens the same dialog as the "continue reading" link in the list (used on mobile)
            const openEntryDialog = () => {
                const targetDialogue = document.querySelector(`[data-dialogue-target="${location.ID}"]`);
                if (targetDialogue) {
                    targetDialogue.showModal();
                }
            };

            // Popup inside the map (desktop only, mobile opens the entry dialog instead)
            const popup = new Popup({ offset: 25 });

            const popupHTML = document.createElement('div');
            popupHTML.className = 'map_marker_popup';

            if (location.Image != null && location.Image != "") {
                const popupimage = document.createElement('img');
                popupimage.className = 'map-marker_image';
                popupimage.src = location.Image;
                popupHTML.appendChild(popupimage);
            }

            const popupContent = document.createElement('div');
            popupContent.className = 'map_marker_content';

            if (location.CategoryTitle != null && location.CategoryTitle != "") {
                const categoryTitle = document.createElement('p');
                categoryTitle.className = 'map-marker_category category--' + location.Category;
                categoryTitle.innerHTML = '<span class="map_icon"></span> ';
                categoryTitle.append(location.CategoryTitle);
                popupContent.appendChild(categoryTitle);
            }

            if (location.Title != null && location.Title != "") {
                const title = document.createElement('h3');
                title.className = 'map-marker_title';
                title.textContent = location.Title;
                popupContent.appendChild(title);
            }

            if (location.Address != null && location.Address != "") {
                const address = document.createElement('p');
                address.className = 'map-marker_address';
                address.innerHTML = '<span class="address_icon"></span> ';
                address.append(location.Address);
                popupContent.appendChild(address);
            }

            if (location.Description != null && location.Description != "") {
                const description = document.createElement('p');
                description.className = 'map-marker_description';
                description.textContent = location.Description;
                popupContent.appendChild(description);
            }

            const buttonWrapper = document.createElement('div');
            buttonWrapper.className = 'map-marker_buttons';

            if (location.Link != null && location.Link != "") {
                const link = document.createElement('a');
                link.className = 'map-marker_link link--button';
                link.href = location.Link;
                link.textContent = location.LinkTitle;
                if (location.LinkOpenInNew) {
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                }
                buttonWrapper.appendChild(link);
            }

            if (buttonWrapper.hasChildNodes()) {
                popupContent.appendChild(buttonWrapper);
            }

            popupHTML.appendChild(popupContent);

            popup.setDOMContent(popupHTML);
            // Width is controlled in CSS (incl. the 500px limit), so it can be animated
            popup.setMaxWidth('none');

            // Toggle between the normal and the wide popup
            const sizeToggle = document.createElement('button');
            sizeToggle.type = 'button';
            sizeToggle.className = 'map_marker_sizetoggle';

            const updateSizeToggle = () => {
                const label = popupWide ? labelNarrow : labelWiden;
                sizeToggle.setAttribute('aria-label', label);
                sizeToggle.title = label;
                sizeToggle.setAttribute('aria-pressed', popupWide ? 'true' : 'false');
                popup.getElement()?.classList.toggle('maplibregl-popup--wide', popupWide);
            };

            sizeToggle.addEventListener('click', (event) => {
                event.stopPropagation();
                popupWide = !popupWide;
                updateSizeToggle();
            });

            popup.on('open', () => {
                if (window.matchMedia('(max-width: 799px)').matches) {
                    popup.remove();
                    openEntryDialog();
                    return;
                }
                // Keep the toggle outside the scrolling content so it stays visible
                popup.getElement().appendChild(sizeToggle);
                updateSizeToggle();

                // Translated label for MapLibre's close button (default is English "Close popup")
                const closeButton = popup.getElement().querySelector('.maplibregl-popup-close-button');
                if (closeButton) {
                    closeButton.setAttribute('aria-label', labelClose);
                    closeButton.title = labelClose;
                }
                marker?.getElement().classList.add('is-active');
            });

            popup.on('close', () => {
                marker?.getElement().classList.remove('is-active');
            });

            var marker = null;

            if (location.Category != null && location.Category != "") {
                const markerdiv = document.createElement('div');
                markerdiv.className = 'map_marker';
                markerdiv.classList.add('category-' + location.Category);

                const icon = document.createElement('div');
                icon.className = 'map_marker_icon';
                icon.classList.add('map_icon');
                icon.classList.add('category-' + location.Category);
                icon.style.backgroundSize = 'contain';

                markerdiv.appendChild(icon);

                marker = new Marker({
                    draggable: false,
                    element: markerdiv,
                })
                    .setLngLat([location.Longitude, location.Latitude])
                    .setPopup(popup)
                    .addTo(map);
            } else {
                marker = new Marker({
                    draggable: false
                })
                    .setLngLat([location.Longitude, location.Latitude])
                    .setPopup(popup)
                    .addTo(map);
            }

            markers.push(marker);

            if (mapfilters.length > 0) {
                mapfilters.forEach(function (mapfilter) {
                    if (mapfilter.getAttribute('data-filtertype') == "categories") {
                        const categories = mapfilter.querySelectorAll('input[type="checkbox"]');
                        //find category with empty value

                        categories.forEach(function (category) {
                            category.addEventListener('change', () => {
                                if (category.checked) {
                                    if (location.Category == category.value) {
                                        marker.getElement().style.display = 'block';
                                    }

                                    maplistentries.forEach(function (maplistentry) {
                                        if (maplistentry.getAttribute('data-category') == category.value) {
                                            maplistentry.style.display = 'block';
                                        }
                                    });
                                } else {
                                    if (location.Category == category.value) {
                                        marker.getElement().style.display = 'none';
                                    }

                                    maplistentries.forEach(function (maplistentry) {
                                        if (maplistentry.getAttribute('data-category') == category.value) {
                                            maplistentry.style.display = 'none';
                                        }
                                    });
                                }
                            });
                            if (category.checked) {
                                if (location.Category == category.value) {
                                    marker.getElement().style.display = 'block';
                                }

                                maplistentries.forEach(function (maplistentry) {
                                    if (maplistentry.getAttribute('data-category') == category.value) {
                                        maplistentry.style.display = 'block';
                                    }
                                });
                            } else {
                                if (location.Category == category.value) {
                                    marker.getElement().style.display = 'none';
                                }

                                maplistentries.forEach(function (maplistentry) {
                                    if (maplistentry.getAttribute('data-category') == category.value) {
                                        maplistentry.style.display = 'none';
                                    }
                                });
                            }
                        });
                    } else if (mapfilter.getAttribute('data-filtertype') == "query") {

                        mapfilter.addEventListener('keyup', (e) => {
                            const searchquery = e.target.value;
                            if (location.Title.toLowerCase().includes(searchquery.toLowerCase())) {
                                console.log(location.Title + " - " + searchquery);
                                marker.getElement().style.display = 'block';
                            } else {
                                marker.getElement().style.display = 'none';
                            }
                        });
                    } else if (mapfilter.getAttribute('data-filtertype') == "clearfilter") {
                        mapfilter.addEventListener('click', () => {
                            mapfilters.forEach(function (mapfilter) {
                                if (mapfilter.getAttribute('data-filtertype') == "categories") {
                                    const categories = mapfilter.querySelectorAll('input[type="checkbox"]');
                                    categories.forEach(function (category) {
                                        category.checked = true;
                                    });
                                } else if (mapfilter.getAttribute('data-filtertype') == "query") {
                                    mapfilter.value = "";
                                }
                            });
                            marker.getElement().style.display = 'block';
                        });
                    }
                });
            }
        });

        const mapjumpers = mapElement.querySelectorAll('[data-behaviour="map-jumper"]');
        if (mapjumpers) {
            mapjumpers.forEach(function (mapjumper) {
                mapjumper.addEventListener('click', () => {
                    const targetLongitude = mapjumper.getAttribute('data-longitude');
                    const targetLatitude = mapjumper.getAttribute('data-latitude');
                    map.jumpTo({ center: [targetLongitude, targetLatitude], zoom: 15 });

                    console.log("Jumping to: " + targetLongitude + ", " + targetLatitude);

                    if (!!mapElement._popups.length) {
                        mapElement._popups.forEach((popup) => {
                            popup.remove()
                        });
                    }
                })
            })
        }

        const maplisttoggle = mapElement.parentElement.querySelector('[data-behaviour="map-list-toggle"]');
        if (maplisttoggle) {
            maplisttoggle.addEventListener('click', () => {
                mapElement.parentNode.classList.toggle('show--list');
            })
        }

        if (maplistentries) {
            maplistentries.forEach(function (maplistentry) {
                /* maplistentry.addEventListener('click', () => {
                    const targetLongitude = maplistentry.getAttribute('data-longitude');
                    const targetLatitude = maplistentry.getAttribute('data-latitude');
                    map.flyTo({ center: [targetLongitude, targetLatitude], zoom: 15 });

                    const popup = document.getElementsByClassName('maplibregl-popup');
                    if ( popup.length ) {
                        popup[0].remove();
                    }
                }); */

                const maplistdetailcollapse = maplistentry.querySelector('[data-behaviour="mapentry-collapsible"]');
                if (maplistdetailcollapse) {
                    const collapsebutton = maplistentry.querySelector('.maplist-entry_collapsebutton');

                    if (collapsebutton) {
                        collapsebutton.addEventListener('click', () => {
                            maplistdetailcollapse.classList.toggle('show--details');

                            const entryText = maplistdetailcollapse.querySelector('.maplist-entry_text');
                            if (maplistdetailcollapse.classList.contains('show--details')) {
                                entryText.style.maxHeight = entryText.scrollHeight + "px";
                            } else {
                                entryText.style.maxHeight = 0;
                            }
                        });
                    }
                }
            });
        }
    })

    const dialogToggles = document.querySelectorAll('[data-behaviour="mapentry-dialogtoggle"]');

    if (dialogToggles) {
        dialogToggles.forEach(function (dialogToggle) {
            dialogToggle.addEventListener('click', () => {
                if (dialogToggle.getAttribute('data-action') == "close") {
                    const targetDialogue = dialogToggle.closest('dialog');
                    if (targetDialogue) {
                        targetDialogue.close();
                    }
                    return;
                }
                if (dialogToggle.getAttribute('data-action') == "open") {
                    const targetDialogue = dialogToggle.closest('.maplist-entry').querySelector('dialog');
                    if (targetDialogue) {
                        targetDialogue.showModal();
                    }
                    return;
                }
            });
        });
    }
}


